import { css } from '@emotion/react';
import { Breakpoint } from '../../hooks/use-container-breakpoints';
export const formContainerStyles = css`
  display: flex;
  justify-content: flex-start;
  flex: 1;
  align-items: flex-start;
`;
export const formStyles = breakpoint => css`
  // by default, form elements seem to pick up 12px
  // top margin so we clear it
  margin: 0;
  flex: 1;
  flex-direction: row;
  justify-content: left;
  display: ${breakpoint <= Breakpoint.Small ? 'block' : 'flex'};
  align-items: flex-start;
`;
export const formInnerStyles = css`
  display: flex;
  flex: 1;
  &[data-multiline='true'] {
    display: block;
  }
`;
export const buttonWrapperStyles = css`
  float: right;
  display: flex;
  &[data-multiline='true'] {
    padding-top: ${"var(--ds-space-100, 8px)"};
  }
`;
export const logoContainerStyles = breakpoint => css`
  display: flex;
  flex-direction: row;
  margin-right: ${"var(--ds-space-050, 4px)"};
  align-items: center;
  align-self: ${breakpoint <= Breakpoint.Small ? 'self-start' : 'initial'};
`;